import {
    useInfiniteList,
    InfiniteList
} from '@shared/components/InfiniteList'
import { useEasyProvider } from '@shared/components/EasyProvider'

import Typography from '@mui/material/Typography'
import LinearProgress from '@mui/material/LinearProgress'
import EstimationItem from '@shared/components/estimations/Item'

export default function Data() {
    const { filterQuery } = useEasyProvider()

    const manager = useInfiniteList({
        key: ['estimations', filterQuery],
        endpoint: 'estimations',
        params: filterQuery
    })

    return manager.isLoading
        ? <LinearProgress />
        : manager.error
            ? <Typography className='centerized'>حدث خطأ</Typography>
            : (
                <>
                    {manager.data.length == 0 ? (
                        <Typography className='centerized'>
                            لا توجد بيانات
                        </Typography>
                    ) : (
                        <InfiniteList
                            manager={manager}
                            additionHeight={100}
                        >
                            {manager.visibleItems.map(({item, options}) =>
                                <EstimationItem
                                    key={item.id}
                                    item={item}
                                    options={options}
                                    infiniteScroll
                                />
                            )}
                        </InfiniteList>
                    )}
                </>
            )
}